import kidsImage from '../../assets/images/kids_visual_filter.png';
import longSleeveImage from '../../assets/images/long_sleeve_visual_filter.png';
import performanceImage from '../../assets/images/performance_visual_filter.png';
import shortSleeveImage from '../../assets/images/short_sleeve_visual_filter.png';
import softTriBlendImage from '../../assets/images/soft_tri_blend_visual_filter.png';
import tallImage from '../../assets/images/tall_visual_filter.png';
import tankTopImage from '../../assets/images/tank_tops_visual_filter.png';
import tieDyeImage from '../../assets/images/tie_dye_visual_filter.png';
import womensImage from '../../assets/images/womens_visual_filter.png';

const visualFilterMapping = {
  'Kids T-shirts': {
    imageUrl: kidsImage,
    title: 'Kids'
  },
  'Long Sleeve T-shirts': {
    imageUrl: longSleeveImage,
    title: 'Long Sleeve'
  },
  'Performance Shirts': {
    imageUrl: performanceImage,
    title: 'Performance'
  },
  'Short Sleeve T-shirts': {
    imageUrl: shortSleeveImage,
    title: 'Short Sleeve'
  },
  'Soft Tri-Blend T-shirts': {
    imageUrl: softTriBlendImage,
    title: 'Soft Tri-Blends'
  },
  'Tall T-shirts': {
    imageUrl: tallImage,
    title: 'Tall'
  },
  'Tank Tops & Sleeveless': {
    imageUrl: tankTopImage,
    title: 'Tank Tops &\n Sleeveless'
  },
  'Tie-Dye T-shirts': {
    imageUrl: tieDyeImage,
    title: 'Tie-Dye'
  },
  "Women's T-shirts": {
    imageUrl: womensImage,
    title: "Women's"
  }
};

export default visualFilterMapping;
